import React, { useEffect } from "react";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import { Helmet } from "react-helmet-async";
import heroImg from "../../assets/images/bydgoszcz/cigar/mohd-jon-ramlan.jpg";
import imgCut from "../../assets/images/bydgoszcz/cigar/mohd-jon-ramlan-cut.jpg";
import imgLight from "../../assets/images/bydgoszcz/cigar/aleksandar-andreev-light.jpg";
import imgSmoke from "../../assets/images/bydgoszcz/cigar/charles-etoroma-palenie.jpg";
import imgAsh from "../../assets/images/bydgoszcz/cigar/angelo-moleele-spalanie.jpg";
import imgCTA from "../../assets/images/bydgoszcz/cigar/matthias-jordan-cta.jpg";

export default function JakPalicCygaro() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: "Jak palić cygaro – poradnik krok po kroku",
            description:
              "Dowiedz się jak poprawnie palić cygaro, jak je rozpalać i jak uniknąć błędów.",
            author: {
              "@type": "Organization",
              name: "Whitebull Steakhouse",
            },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://whitebull.com.pl/jak-palic-cygaro",
            },
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Czy cygaro się zaciąga?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Nie – dym cygara trzyma się w ustach, nie wciąga do płuc.",
                },
              },
              {
                "@type": "Question",
                name: "Jak rozpalić cygaro?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Cygaro należy podgrzewać równomiernie, najlepiej używając zapalniczki gazowej.",
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <div className="bg-black text-white min-h-screen flex flex-col items-center px-4 py-10">
        <FloatingLogoAndButton />
        <div className="mb-20"></div>
        {/* HERO */}
        <section className="max-w-4xl text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Jak palić cygaro? Przewodnik dla początkujących
          </h1>
          <img
            src={heroImg}
            alt="palenie cygara klimat premium dym"
            className="w-full max-w-4xl h-80 object-cover mb-8"
          />
          <p className="text-lg opacity-90">
            Palenie cygara to rytuał, nie nawyk. Dowiedz się krok po kroku, jak
            robić to poprawnie i czerpać z tego pełne doświadczenie.
          </p>
        </section>

        {/* KROKI */}
        <section className="max-w-3xl mb-12 space-y-8">
          <div>
            <h2 className="text-2xl font-semibold mb-3">
              1. Przygotowanie cygara
            </h2>
            <p className="opacity-90">
              Przed zapaleniem cygaro należy przyciąć (tzw. cap). Używa się do
              tego gilotyny lub nożyka.
            </p>
            <img
              src={imgCut}
              alt="przycinanie cygara gilotyna"
              className="w-full h-64 object-cover mt-4"
            />
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">2. Rozpalanie</h2>
            <img
              src={imgLight}
              alt="rozpalanie cygara zapalniczka gazowa"
              className="w-full h-64 object-cover mt-4"
            />
            <p className="opacity-90">
              Najlepiej używać zapalniczki gazowej lub zapałek. Nie przykładaj
              ognia bezpośrednio – podgrzewaj końcówkę cygara, obracając je
              równomiernie.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">
              3. Palenie – najważniejsza zasada
            </h2>
            <p className="opacity-90">
              Cygaro się nie zaciąga do płuc. Dym trzymasz w ustach, delektując
              się smakiem i aromatem.
            </p>
            <img
              src={imgSmoke}
              alt="dym cygara degustacja"
              className="w-full h-64 object-cover mt-4"
            />
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">4. Tempo palenia</h2>
            <p className="opacity-90">
              Zbyt szybkie palenie przegrzewa cygaro i psuje smak. Idealne tempo
              to jedno zaciągnięcie co 30–60 sekund.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">5. Popiół</h2>
            <img
              src={imgAsh}
              alt="popiół cygara spalanie"
              className="w-full h-64 object-cover mt-4"
            />
            <p className="opacity-90">
              Nie strzepuj popiołu co chwilę. Pozwól mu naturalnie opaść – to
              znak dobrze wykonanego cygara.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">6. Zakończenie</h2>
            <img
              src={imgCTA}
              alt="cygaro whisky klimat premium"
              className="w-full h-72 object-cover mt-6"
            />
            <p className="opacity-90">
              Cygaro się nie gasi jak papierosa. Odkłada się je – samo zgaśnie.
            </p>
          </div>
        </section>

        {/* BŁĘDY */}
        <section className="max-w-3xl mb-12">
          <h2 className="text-2xl font-semibold mb-4">Najczęstsze błędy</h2>

          <ul className="space-y-2 opacity-90">
            <li>❌ zaciąganie się do płuc</li>
            <li>❌ zbyt szybkie palenie</li>
            <li>❌ używanie benzynowej zapalniczki</li>
            <li>❌ gaszenie jak papierosa</li>
          </ul>
        </section>

        {/* EXPERIENCE */}
        <section className="max-w-3xl text-center mb-12">
          <h2 className="text-2xl font-semibold mb-4">
            🍽️ Cygaro jako doświadczenie
          </h2>
          <p className="opacity-90">
            Najlepsze doświadczenie uzyskasz w odpowiednim otoczeniu – przy
            dobrym alkoholu i spokojnej atmosferze.
          </p>
        </section>

        {/* CTA */}
        <section className="text-center mb-12">
          <a href="/palarnia-cygar-bydgoszcz" className="underline text-lg">
            → Zobacz palarnię cygar w Whitebull
          </a>
        </section>

        {/* LINKI */}
        <section className="text-center space-y-2">
          <a href="/rodzaje-cygar" className="underline opacity-70 block">
            → Rodzaje cygar
          </a>
          <a href="/historia-cygar" className="underline opacity-70 block">
            → Historia cygar
          </a>
        </section>
      </div>
    </>
  );
}
